import { useSelector } from "react-redux";
import { getCategorySeoLinks } from "../../../../../state/modules/category/selectors";
import Pill from "../../../../CategoryHeader/__variants__/plp-filtering-experience/v2/Pill";
import HorizontalScrollListVariant from "../../../../HorizontalScrollList/components/HorizontalScrollListVariant";
import styles from "./index.css";

const SecondaryCategorySeoLinks = () => {
  const { secondarySeoLinks } = useSelector(getCategorySeoLinks);

  if (!secondarySeoLinks.length) return null;

  return (
    <HorizontalScrollListVariant
      className={styles.secondaryCategorySeoLinks}
      ariaLabel="plp_web_a11y_faceted_nav_carousel"
    >
      {secondarySeoLinks.map(({ friendlyName, linkUrl }) => (
        <Pill
          key={friendlyName}
          friendlyName={friendlyName}
          linkUrl={linkUrl}
        />
      ))}
    </HorizontalScrollListVariant>
  );
};

export default SecondaryCategorySeoLinks;
